#import "../fragments/billing-info-fragment.graphql"

query GetBillingInfo {
    billingInfo {
        ...BillingInfo
    }
}
